.aha-comment-reply {
  padding-bottom: var(--spacer-3);
  gap: var(--spacer-4);
  display: flex;
}

.aha-comment-reply .line {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.aha-comment-reply .line::before {
  content: '';
  background: var(--theme-primary-border);
  width: 2px;
  height: var(--spacer-2);
}

::slotted([slot='avatar']) {
  margin-top: var(--spacer-2);
}

/* Make sure the slot content takes full remaining width */
::slotted([slot='body']) {
  display: flex;
  flex: 1;
  margin-top: var(--spacer-4);
}

.aha-comment-reply__avatar-container {
  width: fit-content;
}
